/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../projects/icemedx-lib/src/login/login.service';
import { AlertService } from "../../projects/icemedx-lib/src/services/alert/alert.service";
import { Subscription } from 'rxjs';
import { IceTypes } from "../../projects/icemedx-lib/src/models/icetypes";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit  {
  title = 'app';
  loggerSubscription: Subscription;

  constructor(private router: Router,
    private loginSvc: LoginService,
    private alertService: AlertService) {
  }

  ngOnInit() {
    this.loggerSubscription = this.alertService.onLogger(IceTypes.LOGTYPE.ltNone)
      .subscribe(logmsg => {
        // To do replace this with code that pushes to user controls (menu bages, indicators, storages, etc...) 
        console.log(logmsg.message);
      });
  }

  ngOnDestroy() {
    this.loggerSubscription.unsubscribe();
  }
}
